<ccl-route-tabs>
    <ccl-route-tab tabTitle='Page Elements' route="page-element">
    </ccl-route-tab>
    <ccl-route-tab tabTitle='Theme' route="theme">
    </ccl-route-tab>
</ccl-route-tabs>
<ccl-section-wrapper>
    <ccl-content-section>
        <router-outlet></router-outlet>
    </ccl-content-section>
</ccl-section-wrapper>